import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ORIENTATION_TYPE_OPTION_IDS } from 'commons/constants';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import JBImage from 'components/essentials/JBImage';
import useIsBrowser from 'hooks/useIsBrowser';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPOptions from '../state/context/usePDPOptions';
import usePdpShowStickyButtons from '../state/context/usePdpShowStickyButtons';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPPriceSection from '../PDPPriceSection';
import PDPLeadTimeUI from '../PDPNameSection/PDPLeadTimeUI';

// Stands in for the sticky price row PDPNameSection turns off in the layout revamp
const PDPStickySummaryBarInner = t0 => {
  const $ = _c(38);
  const {
    slug,
    productCylindoHeroImage: t1
  } = t0;
  const productCylindoHeroImage = t1 === undefined ? null : t1;
  const isBrowser = useIsBrowser();
  const showStickyButtons = usePdpShowStickyButtons();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t2
  } = usePDPOptions();
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    selectedOptionsExtended: t4
  } = t3;
  let t5;
  if ($[2] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const selectedOptionsExtended = t5;
  const {
    data: t6
  } = usePDPFabricFilters(slug);
  const {
    selectedMaterial
  } = t6;
  let t7;
  if ($[4] !== selectedOptionsExtended) {
    t7 = ORIENTATION_TYPE_OPTION_IDS.map(optionId => selectedOptionsExtended?.[optionId]?.value?.value).find(Boolean);
    $[4] = selectedOptionsExtended;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const orientationLabel = t7;
  const heroSrc = basicDetails?.hero_images?.[0]?.img?.url;
  const cylindoSrc = productCylindoHeroImage?.src;
  const fabricLabel = selectedMaterial?.label || selectedMaterial?.value;
  const t8 = !showStickyButtons;
  let t9;
  if ($[6] !== showStickyButtons || $[7] !== t8) {
    t9 = classNames("fixed inset-x-0 top-0 z-[999] bg-white shadow-md transition-[opacity,visibility] ease-in max-[1023px]:hidden", {
      "opacity-0 invisible pointer-events-none": t8,
      "opacity-100": showStickyButtons
    });
    $[6] = showStickyButtons;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== cylindoSrc || $[10] !== heroSrc) {
    t10 = cylindoSrc ? <img src={cylindoSrc} alt="" width="112" height="75" className="h-[75px] w-[112px] object-contain flex-none" /> : heroSrc && <JBImage src={heroSrc} width="112" height="75" className="h-[75px] w-[112px] object-contain flex-none" />;
    $[9] = cylindoSrc;
    $[10] = heroSrc;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = basicDetails?.name;
  let t12;
  if ($[12] !== t11) {
    t12 = <div className="text-base font-bold text-gray">{t11}</div>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <PDPPriceSection />;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t12) {
    t14 = <div className="flex-none">{t12}{t13}</div>;
    $[15] = t12;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== fabricLabel || $[18] !== selectedMaterial) {
    t15 = fabricLabel && <div><div className="text-gray-light2">Fabric:</div><div className="flex items-center gap-2 font-bold">{selectedMaterial.image && <JBImage src={selectedMaterial.image} width="20" height="20" className="h-5 w-5 rounded-full object-cover" />}{fabricLabel}</div>{!!selectedMaterial.pet_friendly && <div className="text-xs text-gray-light2">(Pet Friendly)</div>}</div>;
    $[17] = fabricLabel;
    $[18] = selectedMaterial;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== orientationLabel) {
    t16 = orientationLabel && <div><div className="text-gray-light2">Orientation:</div><div className="font-bold">{orientationLabel}</div></div>;
    $[20] = orientationLabel;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t15 || $[23] !== t16) {
    t17 = <div className="flex gap-8 border-0 border-l border-solid border-gray-light6 pl-8 text-sm text-gray">{t15}{t16}</div>;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <PDPAddToBagSection stickyDesktopButtonOnly={true} isLayoutRevamp={true} />;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== isBrowser) {
    t19 = isBrowser && <PDPLeadTimeUI mode="pdp" isLayoutRevamp={true} />;
    $[26] = isBrowser;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t19) {
    t20 = <div className="ml-auto w-[400px] flex-none text-center">{t18}{t19}</div>;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t10 || $[31] !== t14 || $[32] !== t17 || $[33] !== t20) {
    t21 = <FixedWidthContainer wide={true} className="flex items-center gap-8 !py-3">{t10}{t14}{t17}{t20}</FixedWidthContainer>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t17;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t21 || $[36] !== t9) {
    t22 = <div data-xc="PDPStickySummaryBar" className={t9}>{t21}</div>;
    $[35] = t21;
    $[36] = t9;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  return t22;
};
PDPStickySummaryBarInner.propTypes = {
  slug: PropTypes.string,
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired
  })
};

// Null fallback: a loader here would sit in normal flow and push the page down
const PDPStickySummaryBar = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader fallback={null}><PDPStickySummaryBarInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPStickySummaryBar;